export const SIDE_PADDING = 20;
export const SELECTED_CATEGORY_ID_DATA = 'data-selected-category-id';
